import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import About from './Components/About';
import Projects from './Components/Projects';
import Jobs from './Components/Jobs';
import Background from './Components/Background';
import CustomCursor from './Components/CustomCursor';
import {ReactComponent as GitIcon} from './mdi_github.svg'
import {ReactComponent as LinkIcon} from './mdi_linkedin.svg'  

function App() {
  const [currentSelection, setCurrentSelection] = useState('');

  // Refs for sections
  const sections = [
    { id: 'About', ref: useRef(null) },
    { id: 'Projects', ref: useRef(null) },
    { id: 'Jobs', ref: useRef(null) },
    { id: 'Contact', ref: useRef(null) },
  ];

  // Scroll to section when clicking a nav item
  const scrollToSection = (id) => {
    setCurrentSelection(id);
    const section = document.getElementById(id);
    const scrollContainer = document.getElementById('content'); 
  
    if (section && scrollContainer) {
      scrollContainer.scrollTo({
        top: section.offsetTop - scrollContainer.offsetTop,
        behavior: 'smooth'
      });
    }
  };

  // Auto-update nav when scroll
  useEffect(() => {
    const detailsSection = document.getElementById('content');
  
    if (!detailsSection) {
      return;
    }
  
    let isScrolling;
  
    const handleScroll = () => {
      window.clearTimeout(isScrolling);
  
      isScrolling = setTimeout(() => {
        let closestSection = '';
        let minDistance = Number.MAX_VALUE;
  
        sections.forEach(({ id, ref }) => {
          if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const distance = Math.abs(rect.top);
  
            if (distance < minDistance) {
              minDistance = distance;
              closestSection = id;
            }
          }
        });
  
        setCurrentSelection(closestSection);
      }, 150);
    };
  
    detailsSection.addEventListener('scroll', handleScroll);
    handleScroll();
  
    return () => {
      clearTimeout(isScrolling);
      detailsSection.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <div className="App">
      <header className="App-header">
      <Background />
      <CustomCursor/>
        <div className="whiteborder" id="content">
          <div className="maxWidth">
            <div className="top flex">
              <div className="left">
                <div id="info">
                  <h1>Elijah Camacho</h1>
                  <p>Web Designer & Developer</p>
                  <hr />
                  <p>
                    A passionate web designer and full-stack engineer dedicated to creating
                    dynamic, user-friendly, and impactful digital experiences.
                  </p>

                  <div id="nav">
                    <ul>
                      <li>
                        {currentSelection !== 'About' ? (
                          <p onClick={() => scrollToSection('About')}>Home</p>
                        ) : (
                          <div className="circle"></div>
                        )}
                      </li>
                      <li>
                        {currentSelection !== 'Projects' ? (
                          <p onClick={() => scrollToSection('Projects')}>Projects</p>
                        ) : (
                          <div className="circle"></div>
                        )}
                      </li>
                      <li>
                        {currentSelection !== 'Jobs' ? (
                          <p onClick={() => scrollToSection('Jobs')}>Experience</p>
                        ) : (
                          <div className="circle"></div>
                        )}
                      </li>
                      <li>
                        {currentSelection !== 'Contact' ? (
                          <p onClick={() => scrollToSection('contact')}>Contact</p>
                        ) : (
                          <div className="circle"></div>
                        )}
                      </li>
                    </ul>
                  </div>

                  <div className="flex" id="socials">
                        <a href="https://github.com/SanginiusLives"><GitIcon width={30} height={30} /></a>
                        <a href="https://www.linkedin.com/in/elijah-camacho-ab1774189/"><LinkIcon width={30} height={30} /></a>
                  </div>
                </div>
              </div>

              <div className="right" id="details">
              {sections.map(({ id, ref }) => (
                  <section key={id} id={id} ref={ref} >
                    {id === 'About' && <About />}
                    {id === 'Projects' && <Projects />}
                    {id === 'Jobs' && <Jobs />}
                  </section>
                ))}
                <section id="contact">
                  <h2>Contact</h2>
                  <p>Reach out to me at <a href="mailto:elijahcamacho.business@gmail.com">elijahcamacho.business@gmail.com</a></p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
